import { ActiveNavLink } from "components/common/ActiveNavLink";
import { HierarchyChildReadDto } from "functions/api/hierarchy/HierarchyChildReadDto";
import { getHierarchyBaseUrl } from "../../contexts/hierarchy/getHierarchyBaseUrl";

interface ChildLinkProps {
  hierarchy: HierarchyChildReadDto;
}

/**
 * Link to a child hierarchy. Renders the child name as a navigation link to
 * the child's base hierarchy page.
 *
 * @param props - Destructured props object.
 * @param props.hierarchy - Child hierarchy DTO to render.
 */
export const ChildLink = ({ hierarchy }: ChildLinkProps): React.ReactElement => {
  return (
    <div style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}>
      <ActiveNavLink
        id={`hierarchylinks-child-${name}`}
        to={`${getHierarchyBaseUrl(hierarchy)}`}
        style={{
          paddingLeft: "0.75rem",
          textIndent: "-0.75rem",
        }}
      >
        {hierarchy.name}
      </ActiveNavLink>
    </div>
  );
};

ChildLink.displayName = "ChildLink";
